import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import {
    FILTER_NAMES,
    filterDropdownCustomMargin,
    generalFiltersBlockStyle,
    useMediaQueries
} from "shared";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

export const DeviceGroupFilters = () => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { fromLg, toLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && (
                <FilterDropdown
                    filter={FILTER_NAMES.ConfigurationFileId}
                    placeholder={t(
                        `Filter##${FILTER_NAMES.ConfigurationFileId}`
                    )}
                    disabled={hasNoPermissionToRead}
                    css={css([filterDropdownCustomMargin])}
                />
            )}

            <FilterButton
                onOpen={handleOpenMenu}
                isDisabled={hasNoPermissionToRead}
            >
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && (
                        <FilterDropdown
                            filter={FILTER_NAMES.ConfigurationFileId}
                            placeholder={t(
                                `Filter##${FILTER_NAMES.ConfigurationFileId}`
                            )}
                        />
                    )}

                    <FilterDropdown
                        filter={FILTER_NAMES.FirmwareFileId}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.FirmwareFileId}`
                        )}
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.FtConfigurationFileId}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.FtConfigurationFileId}`
                        )}
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.FtOneWireAuthListFileId}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.FtOneWireAuthListFileId}`
                        )}
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.FtBluetoothAuthListFileId}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.FtBluetoothAuthListFileId}`
                        )}
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.FtFirmwareFileId}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.FtFirmwareFileId}`
                        )}
                    />
                </div>
            </FilterMenu>
        </div>
    );
};
